import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "../components/flexproducts";
import Header from "../headers_footer/header";

const Biotique = () => {

return (

<div>

<Navbar />
<Flexproducts type="biotique" />
<Header></Header>

</div>

);
};

export default Biotique;